




import { Vue, Component, Prop } from "vue-property-decorator";

import SegmentControl from "@share/common/segment/Segment.vue";
import { SegmentDataItem } from "@share/common/segment/SegmentData";

@Component({ components: { SegmentControl } })

export default class LangSelector extends Vue {

    @Prop() langList: string[];
    @Prop() selectedLang: string;
    @Prop() invalidLangs: string[] | undefined

    select({ value }: SegmentDataItem) {
        this.$emit('select', value)
    }

    get segmentData(): SegmentDataItem[] {

        return this.langList.map((lang) => {
            return {
                active: this.selectedLang === lang,
                title: lang,
                value: lang,
                marked: this.invalidLangs?.includes(lang)
            }
        })
    }

}

